export const NEW_USER_PASSWORD_RESET = 'NEW_USER_PASSWORD_RESET';
export const CHANGE_LOGIN_FORM = 'CHANGE_LOGIN_FORM';
export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const SUCCESS = '_SUCCESS';
export const ERROR = '_ERROR';
export const RESET_DEFAULT_PASSWORD = 'RESET_DEFAULT_PASSWORD';
export const THROW_NOTIFICATION = 'THROW_NOTIFICATION';
export const CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION';
export const CLOSE_ALL_NOTIFICATIONS = 'CLOSE_ALL_NOTIFICATIONS';
export const TOGGLE_LAYER = 'TOGGLE_LAYER';
export const CHANGE_MAP_FILTERS = 'CHANGE_MAP_FILTERS';
export const REQUEST_LOGGED_USER_INFO = 'REQUEST_LOGGED_USER_INFO';
export const SET_USER_SETTINGS = 'SET_USER_SETTINGS';
export const MAP_LOADED = 'MAP_LOADED';
export const MAP_LAYERS_LOADED = 'MAP_LAYERS_LOADED';
export const SET_LAYERS = 'SET_LAYERS';
export const CHANGE_REGION = 'CHANGE_REGION';
export const SET_REGIONS = 'SET_REGIONS';
export const SET_SELECTED_HOUR = 'SET_SELECTED_HOUR';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';
export const SET_SELECTED_DATE_FROM_TILES = 'SET_SELECTED_DATE_FROM_TILES';
export const SET_SCR_TRACKS_DATE = 'SET_SCR_TRACKS_DATE';
export const SET_SCR_TRACKS_SELECTED_SHIFT = 'SET_SCR_TRACKS_SELECTED_SHIFT';
export const SET_SELECTED_REBALANCE_PERIOD = 'SET_SELECTED_REBALANCE_PERIOD';
export const SET_SELECTED_REBALANCE_DATE = 'SET_SELECTED_REBALANCE_DATE';
export const SET_SELECTED_REBALANCE_ROLES = 'SET_SELECTED_REBALANCE_ROLES';
export const SET_SELECTED_REBALANCE_MIN_COUNT = 'SET_SELECTED_REBALANCE_MIN_COUNT';
export const SET_SELECTED_REBALANCE_DAY_MODE = 'SET_SELECTED_REBALANCE_DAY_MODE';
export const TOGGLE_TERRAIN_3D = 'TOGGLE_TERRAIN_3D';
export const SET_TERRAIN_MODE = 'SET_TERRAIN_MODE';

// Пользовательские GeoJSON-слои (drag&drop файла на карту)
export const ADD_USER_GEOJSON_LAYER = 'ADD_USER_GEOJSON_LAYER';
